export { default } from './UnscoredTable'
